import { deleteRatesCityRequest } from "../../data/ratesCityApi";

export async function deleteTarifaCityUseCase(id) {
  if (!id) {
    throw new Error("El id de la tarifa de ciudad es obligatorio.");
  }

  return await deleteRatesCityRequest(id);
}
